import React from 'react';
import { Box, TablePagination } from '@mui/material';

interface PaginatedTablePaginationProps {
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowsPerPageOptions?: number[];
  showFirstButton?: boolean;
  showLastButton?: boolean;
}

const PaginatedTablePagination: React.FC<PaginatedTablePaginationProps> = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25, 50],
  showFirstButton = true,
  showLastButton = true,
}) => {
  return (
    <Box
      sx={{
        flexShrink: 0,
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <TablePagination
        component="div"
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        sx={{ overflow: 'visible' }}
      />
    </Box>
  );
};

export default PaginatedTablePagination;
